import { render, staticRenderFns } from "./SolidRingForResult.vue?vue&type=template&id=18bf9753&scoped=true&"
import script from "./SolidRingForResult.vue?vue&type=script&lang=js&"
export * from "./SolidRingForResult.vue?vue&type=script&lang=js&"
import style0 from "./SolidRingForResult.vue?vue&type=style&index=0&id=18bf9753&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf9753",
  null
  
)

export default component.exports